export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;
export const MODE = import.meta.env.MODE;
export const DOMAIN_URL =
    import.meta.env.VITE_DOMAIN_URL || "https://vitotechnology.com";
export const VERSION = (import.meta.env.VITE_VERSION || "0.0.0").replace(
    "v",
    "",
);
